import React from 'react';
import { EProjectStatus } from '@app/swagger-types';
import { TesterProjectsPageBody } from '@app/domain/project/components/TesterProjectsPageBody';

export const TesterLiveProjectsPage: React.FC = () => {
  return <TesterProjectsPageBody filterStatus={EProjectStatus.LIVE} />;
};
